
import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { useAuth } from '@/hooks/useAuth';
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
} from "@/components/ui/navigation-menu";

export function DesktopNav() {
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  
  // Check if the current path matches the given path
  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  return (
    <NavigationMenu className="hidden md:flex z-50">
      <NavigationMenuList className="bg-background">
        <NavigationMenuItem>
          <Link 
            to="/"
            className={cn(navigationMenuTriggerStyle(), isActive('/') && !isActive('/dashboard') ? 'bg-accent text-accent-foreground' : '')}
          >
            Home
          </Link>
        </NavigationMenuItem>
        
        {!isAuthenticated && (
          <>
            <NavigationMenuItem>
              <Link 
                to="/demo"
                className={cn(navigationMenuTriggerStyle(), isActive('/demo') || isActive('/sample-dashboard') ? 'bg-accent text-accent-foreground' : '')}
              >
                Demo
              </Link>
            </NavigationMenuItem>
            
            <NavigationMenuItem>
              <Link 
                to="/faq"
                className={cn(navigationMenuTriggerStyle(), isActive('/faq') ? 'bg-accent text-accent-foreground' : '')}
              >
                FAQ
              </Link>
            </NavigationMenuItem>
            
            <NavigationMenuItem>
              <Link 
                to="/testimonials"
                className={cn(navigationMenuTriggerStyle(), isActive('/testimonials') ? 'bg-accent text-accent-foreground' : '')}
              >
                Testimonials
              </Link>
            </NavigationMenuItem>
          </>
        )}
        
        <NavigationMenuItem>
          <Link 
            to="/contact"
            className={cn(navigationMenuTriggerStyle(), isActive('/contact') ? 'bg-accent text-accent-foreground' : '')}
          >
            Contact
          </Link>
        </NavigationMenuItem>

        {isAuthenticated && (
          <NavigationMenuItem>
            <Link 
              to="/dashboard"
              className={cn(navigationMenuTriggerStyle(), isActive('/dashboard') ? 'bg-accent text-accent-foreground' : '')}
            >
              My Dashboard
            </Link>
          </NavigationMenuItem>
        )}
      </NavigationMenuList>
    </NavigationMenu>
  );
}
